export type ClassValue = string | false | null | undefined;

/** Joins class names, dropping falsy values. Variants are composed from disjoint classes, so no merge step is needed. */
export const cx = (...classes: ClassValue[]): string => classes.filter(Boolean).join(' ');
